// extracted by mini-css-extract-plugin
export var contentContainer = "_3g-2";
export var customerActivityFilterDrawer = "_3g-4";
export var drawerCloseButtonContainer = "_3g-5";
export var emptyStateText = "_3g-3";
export var headerContainer = "_3g-1";
export var panelContainer = "_3g-0";